module.exports = __webpack_public_path__ + "static/media/1POLICY18.129e7189.jpg";